import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/image/logo.png";
import { persistor } from "../redux/store/store";
import { IoSearch } from "@react-icons/all-files/io5/IoSearch";
import { IoCart } from "@react-icons/all-files/io5/IoCart";
import { IoMenuSharp } from "@react-icons/all-files/io5/IoMenuSharp";
import { IoClose } from "@react-icons/all-files/io5/IoClose";
import { IoHeart } from "@react-icons/all-files/io5/IoHeart";
import { FaTachometerAlt } from "@react-icons/all-files/fa/FaTachometerAlt";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { FaShoppingCart } from "@react-icons/all-files/fa/FaShoppingCart";
import { FaMapMarkerAlt } from "@react-icons/all-files/fa/FaMapMarkerAlt";
import { FaSignOutAlt } from "@react-icons/all-files/fa/FaSignOutAlt";
import { FaUser } from "@react-icons/all-files/fa/FaUser";
import {FaPhone} from "react-icons/fa";
import { Circle } from "@chakra-ui/react";

// If Chakra isn't set up correctly, Circle may be an object instead of a component.
// Use the fallback badge to prevent the "Element type is invalid" runtime crash.

import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { setCatalystUser } from "../redux/reduxSlice/SingIn&Singup/SingInSlice";
import { logout } from "../redux/reduxSlice/SingIn&Singup/SingInSlice";
import { getwebsiteProduct } from "../redux/reduxApi/website/ProductReduxApi";
import { ChevronDown, ChevronUp, Clock } from "lucide-react";
import toast from "react-hot-toast";
import { cartProductCount } from "../redux/reduxApi/website/CartProductCount";
import { getWishlistCount } from "../redux/reduxApi/website/WishlistApi";

const NavBar = () => {
  // ----- Catalyst User State -----
  const [user, setUser] = useState(null); // null = not logged in
  console.log("Navbar render - user state:", user);
  const [isLoadingUser, setIsLoadingUser] = useState(true);

  // ----- UI States -----
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const mobDropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  // Redux selectors
  const cartCount = useSelector((state) => state.Cart.CartCount.count || 0);
  const wishlistCount = useSelector(
    (state) => state.Wishlist.WishListCount.count || 0
  );
const isLoggedIn = !!user?.isAppUser;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isActive = (path) => location.pathname === path;
  const onClose = () => setIsOpen(false);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const customerId = localStorage.getItem("customerId");
  
    if (authToken || (customerId && customerId.trim() !== "")) {
      setUser({ isAppUser: true });
      setIsLoadingUser(false);
    }
  }, []);
  useEffect(() => {
    let cancelled = false;
    let intervalId;
  
    const authToken = localStorage.getItem("authToken");
    const customerId = localStorage.getItem("customerId");
    if (authToken || (customerId && customerId.trim() !== "")) {
      setIsLoadingUser(false);
      return;
    }
  
    const attemptCatalystLogin = async () => {
      if (!window.catalyst) return;
      setIsLoadingUser(true);
      try {
        const response = await window.catalyst.userManagement.getCurrentProjectUser();
        if (cancelled) return;
  
        console.log("Catalyst user response:", response);
  
        if (response?.content?.is_confirmed) {
          const userData = {
            userId: response.content.user_id,
            firstName: response.content.first_name,
            lastName: response.content.last_name,
            email: response.content.email_id,
            isConfirmed: true,
            raw: response.content,
          };
          setUser(userData);
          localStorage.setItem("catalystUser", JSON.stringify(userData));
          dispatch(setCatalystUser(userData));
          const cid = localStorage.getItem("customerId");
          if (cid && cid.trim() !== "") {
            dispatch(cartProductCount());
            dispatch(getWishlistCount());
          }
        } else {
          setUser(null);
          localStorage.removeItem("catalystUser");
          dispatch(logout());
        }
      } catch (err) {
        console.error("Error fetching Catalyst user:", err);
        setUser(null);
        localStorage.removeItem("catalystUser");
      } finally {
        if (!cancelled) {
          setIsLoadingUser(false);
        }
      }
    };
  
    // If catalyst is already available, run immediately
    if (window.catalyst) {
      attemptCatalystLogin();
    } else {
      // Poll until it appears
      intervalId = setInterval(() => {
        if (window.catalyst) {
          clearInterval(intervalId);
          attemptCatalystLogin();
        }
      }, 500);
    }
  
    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [dispatch]); 
  // useEffect(() => {
  //   if (isLoggedIn) {
  //     dispatch(getWishlistCount());
  //     dispatch(cartProductCount());
  //   }
  // }, [isLoggedIn, dispatch]);

  const handleLogout = async () => {
    if (!window.catalyst) {
      toast.error("Catalyst SDK not available");
      return;
    }

    try {
      setUser(null);
      localStorage.removeItem("catalystUser");
      localStorage.removeItem("authToken");
      localStorage.removeItem("customerId");
      localStorage.removeItem("firstName");
      localStorage.removeItem("lastName");
      localStorage.removeItem("userId");
      localStorage.removeItem("email");
      persistor.purge();
      dispatch(logout());

      const redirectURL = window.location.origin + "/";
      window.catalyst.auth.signOut(redirectURL);
    } catch (err) {
      console.error("Logout error:", err);
      toast.error(err?.message || "Logout failed");
    }
  };
    useEffect(() => {
    const checkLoginStatus = () => {
      const customerId = localStorage.getItem("customerId");
      const authToken = localStorage.getItem("authToken");
      const hasAuthToken = !!authToken;
      const hasCustomerId = customerId && customerId.trim() !== "";
      const hasCredentials = hasAuthToken || hasCustomerId;
  
      // console.log("🔍 Navbar checkLoginStatus:", { hasAuthToken, hasCustomerId, currentUser: !!user });
  
      if (hasCredentials && !user) {
        // console.log("✅ Navbar: User logged in (credentials found)");
        setUser({ isAppUser: true });
      } else if (!hasCredentials && user) {
        // console.log("❌ Navbar: User logged out (credentials removed)");
        setUser(null);
      }
    };
  
    const handleStorageChange = (e) => {
      if (e.key === "customerId" || e.key === "authToken" || e.key === null) {
        checkLoginStatus();
      }
    };

   
  
    const handleAppLogin = () => {
      checkLoginStatus();
    };

    // Run once on mount
    checkLoginStatus();

    // Add event listeners
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("appUserLoggedIn", handleAppLogin);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("appUserLoggedIn", handleAppLogin);
    };
  }, [user]);
  
  // ----- Search handling (uncomment if needed) -----
  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value.trim()) {
      dispatch(
        getwebsiteProduct({
          search: [{ field: "name", operation: "like", value }],
        })
      );
    } else {
      dispatch(getwebsiteProduct());
    }
  };
  const clearSearch = () => {
    dispatch(getwebsiteProduct());
    setSearchTerm("");
  };


  // ----- Close dropdown when clicking outside -----
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideDesktop =
        dropdownRef.current && !dropdownRef.current.contains(event.target);
      const isOutsideMobile =
        mobDropdownRef.current && !mobDropdownRef.current.contains(event.target);
      if (isOutsideDesktop && isOutsideMobile) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (isLoadingUser) {
    return <div className="fixed top-0 w-full bg-[#034C8C] h-16 z-10"></div>;
  }

 
  return (
    <>
      <div className="fixed w-full top-0 z-10">
        {/* Top bar */}
        <header className="bg-[#4E8CC4] text-white py-2 border-b border-gray-700 hidden sm:block">
          <div className="mx-auto flex justify-between items-center px-[8.3%]">
            <div className="flex items-center space-x-3">
              <FaPhone size="20px" className="text-yellow-500" />
              <a href="#" className="no-underline text-white">
                Call us 604-581-5464
              </a>
            </div>
            <div className="flex items-center space-x-3">
              <Clock size="22px" className="text-yellow-500" />
              <span>Opening hours: Mon - Sat: 9:00am To 5:30pm</span>
              <Link to="/contact-us" className="md:hidden block">
                Click to discover Locations
              </Link>
            </div>
          </div>
        </header>

        {/* Main navigation */}
        <nav
          className="bg-[#034C8C] text-white py-2 lg:px-[7%] border-b border-black-700 flex lg:justify-end items-center"
          style={{ height: `${isSearchOpen ? "120px" : "75px"}` }}
        >
          <div className="container mobile flex justify-between items-center md:mx-4">
            {/* Logo */}
            <Link to="/homepage">
              <img
                src={logo}
                alt="Mobex Logo"
                className="h-10 md:h-14"
                style={{ marginRight: "-40px" }}
              />
            </Link>

            {/* Desktop menu links */}
            <div className="hidden lg:flex justify-between items-center w-2/5">
              <Link
                to="/homepage"
                className="text-orange-500 no-underline font-bold"
              >
                <button className="relative text-[17px] group hover:scale-110 transition-all duration-500 font-bold text-white no-underline cursor-pointer flex items-center">
                  Home
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-white transition-all duration-500 ${
                      isActive("/homepage") ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </button>
              </Link>

              {/* Services dropdown desktop */}
              <div
                className="relative"
                onMouseLeave={() => setIsServiceOpen(false)}
              >
                <button
                  onMouseEnter={() => setIsServiceOpen(true)}
                  onClick={() => setIsServiceOpen(!isServiceOpen)}
                  className="relative text-[17px] group hover:scale-110 transition-all duration-500 font-bold text-white no-underline cursor-pointer flex items-center"
                >
                  Services
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-white transition-all duration-500 ${
                      isActive("/services")
                        ? "w-full"
                        : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </button>
                {isServiceOpen && (
                  <div
                    className="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-[400px] absolute"
                    onMouseLeave={() => setIsServiceOpen(false)}
                  >
                    <div className="grid grid-cols-2 gap-4">
                      <ul className="py-2 text-sm text-gray-700 pl-0">
                        <li>
                          <a
                            href="#breaks"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Brake
                          </a>
                        </li>
                        <li>
                          <a
                            href="#clutch"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Clutch & Transmissions
                          </a>
                        </li>
                        <li>
                          <a
                            href="#electrical"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Electrical
                          </a>
                        </li>
                        <li>
                          <a
                            href="#engine"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Engine Diagnostics
                          </a>
                        </li>
                        <li>
                          <a
                            href="#exhaust"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Exhaust
                          </a>
                        </li>
                      </ul>
                      <ul className="py-2 text-sm text-gray-700 pl-0">
                        <li>
                          <a
                            href="#fuel"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Fuel
                          </a>
                        </li>
                        <li>
                          <a
                            href="#maintenance"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Maintenance
                          </a>
                        </li>
                        <li>
                          <a
                            href="#radiators"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Radiators & Cooling
                          </a>
                        </li>
                        <li>
                          <a
                            href="#suspension"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Suspension & Steering
                          </a>
                        </li>
                        <li>
                          <a
                            href="#transfer"
                            className="px-2 block py-2 hover:bg-gray-100 no-underline"
                            onClick={() => setIsServiceOpen(false)}
                          >
                            Transfer Case & Differentials
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <Link to="/shop" className="text-orange-500 no-underline font-bold">
                <button className="relative text-[17px] group hover:scale-110 transition-all duration-500 font-bold text-white no-underline cursor-pointer">
                  Shop
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-white transition-all duration-500 ${
                      isActive("/shop") ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </button>
              </Link>

              <Link to="/blog" className="text-orange-500 no-underline font-bold">
                <button className="relative text-[17px] group hover:scale-110 transition-all duration-500 font-bold text-white no-underline cursor-pointer">
                  Blogs
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-white transition-all duration-500 ${
                      isActive("/blog") ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </button>
              </Link>

              <Link
                to="/about-us"
                className="text-orange-500 no-underline font-bold"
              >
                <button className="relative text-[17px] group hover:scale-110 transition-all duration-500 font-bold text-white no-underline cursor-pointer">
                  About us
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-white transition-all duration-500 ${
                      isActive("/about-us")
                        ? "w-full"
                        : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </button>
              </Link>

              <Link
                to="/contact-us"
                className="text-orange-500 no-underline font-bold"
              >
                <button className="relative text-[17px] group hover:scale-110 transition-all duration-500 font-bold text-white no-underline cursor-pointer">
                  Contact us
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-white transition-all duration-500 ${
                      isActive("/contact-us")
                        ? "w-full"
                        : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </button>
              </Link>
            </div>

            {/* Right side icons + user menu (desktop) */}
            <div className="hidden md:flex items-center justify-end">
              <div className="flex lg:pl-24 items-center">
                {/* Cart & Wishlist - visible only when logged in */}
                {isLoggedIn && (
                  <div className="flex items-center gap-3">
                    <Link to="/account/wishlist" className="relative">
                      <IoHeart size="28px" className="hover:text-gray-100" />
                      {wishlistCount > 0 && (
                        <Circle
                          size="3"
                          bg="red"
                          color="white"
                          className="absolute -top-2 left-4 p-2 text-[11px]"
                        >
                          {wishlistCount}
                        </Circle>
                      )}
                    </Link>
                    <Link to="/addtocart" className="relative mx-3">
                      <IoCart size="30px" className="hover:text-gray-100" />
                      {cartCount > 0 && (
                        <Circle
                          size="3"
                          bg="red"
                          color="white"
                          className="absolute -top-2 left-5 text-xs p-2"
                        >
                          {cartCount}
                        </Circle>
                      )}
                    </Link>
                  </div>
                )}

                {/* Login or User Menu */}
                {!isLoggedIn ? (
                  <div
                    className="flex items-center"
                    style={{ position: "relative", right: "100px" }}
                  >
                    <Link
                      to="/login"
                      className="text-white-500 no-underline font-bold"
                    >
                      <button
                        className="relative text-white-500 ml-10 no-underline font-bold"
                        type="button"
                      >
                        Login
                      </button>
                    </Link>
                  </div>
                ) : (
                  <div className="relative ml-10" ref={dropdownRef}>
                    <button
                      onClick={() => setDropdownVisible(!dropdownVisible)}
                      className="text-white font-bold flex items-center rounded-lg border border-white p-2"
                      style={{ position: "relative", right: "17px" }}
                    >
                      <FaUser size="28px" className="text-yellow-500 mr-1" />
                      My Account
                    </button>
                    {dropdownVisible && (
                      <div className="absolute right-0 mt-2 w-[190px] bg-white shadow-lg rounded-md z-10 overflow-hidden">
                        <Link
                          to="/account/dashboard"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaTachometerAlt className="mr-2" /> Dashboard
                        </Link>
                        <Link
                          to="/account/wishlist"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaHeart className="mr-2" /> Wishlist
                        </Link>
                        <Link
                          to="/account/orders"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaShoppingCart className="mr-2" /> Orders
                        </Link>
                        <Link
                          to="/account/edit-address"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaMapMarkerAlt className="mr-2" /> Addresses
                        </Link>
                        <Link
                          to="/account/edit-account"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaUser className="mr-2" /> Account details
                        </Link>
                        <button
                          onClick={() => {
                            handleLogout();
                            setDropdownVisible(false);
                          }}
                          className="flex items-center w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-200 border-t"
                        >
                          <FaSignOutAlt className="mr-2" /> Log out
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <button
                className="text-white lg:hidden md:block"
                onClick={() => setIsOpen(true)}
              >
                <IoMenuSharp className="h-8 w-8" />
              </button>
            </div>

            {/* Mobile view */}
            <div className="d-block d-sm-none flex items-center">
              <div className="flex items-center gap-1">
                {/* Cart & Wishlist - visible only when logged in */}
                {isLoggedIn && (
                  <>
                    <Link to="/account/wishlist" className="relative">
                      <IoHeart size="25px" style={{ marginRight: "-16px" }} />
                      {wishlistCount > 0 && (
                        <Circle
                          size="4"
                          bg="red"
                          color="white"
                          className="absolute -top-2 left-3 p-2 text-[14px]"
                        >
                          {wishlistCount}
                        </Circle>
                      )}
                    </Link>
                    <Link to="/addtocart" className="relative mx-6">
                      <IoCart size="30px" style={{ marginRight: "-16px" }} />
                      {cartCount > 0 && (
                        <Circle
                          size="4"
                          bg="red"
                          color="white"
                          className="absolute -top-2 left-4"
                        >
                          {cartCount}
                        </Circle>
                      )}
                    </Link>
                  </>
                )}

                {/* Login or User Menu */}
                {!isLoggedIn ? (
                  <Link
                    to="/login"
                    className="text-white font-bold no-underline"
                    style={{ position: "relative", right: "8px" }}
                  >
                    Login
                  </Link>
                ) : (
                  <div className="relative" ref={mobDropdownRef}>
                    <button
                      onClick={() => setDropdownVisible(!dropdownVisible)}
                      className="text-white flex items-center whitespace-nowrap"
                    >
                      <FaUser size="23px" />
                    </button>
                    {dropdownVisible && (
                      <div className="absolute right-0 mt-2 w-[190px] bg-white shadow-lg rounded-md z-10">
                        <Link
                          to="/account/dashboard"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaTachometerAlt className="mr-2" /> Dashboard
                        </Link>
                        <Link
                          to="/account/wishlist"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaHeart className="mr-2" /> Wishlist
                        </Link>
                        <Link
                          to="/account/orders"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaShoppingCart className="mr-2" /> Orders
                        </Link>
                        <Link
                          to="/account/edit-address"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaMapMarkerAlt className="mr-2" /> Addresses
                        </Link>
                        <Link
                          to="/account/edit-account"
                          className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                          onClick={() => setDropdownVisible(false)}
                        >
                          <FaUser className="mr-2" /> Account details
                        </Link>
                        <button
                          onClick={() => {
                            handleLogout();
                            setDropdownVisible(false);
                          }}
                          className="flex items-center w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-200 border-t"
                        >
                          <FaSignOutAlt className="mr-2" /> Log out
                        </button>
                      </div>
                    )}
                  </div>
                )}
                <button className="text-white" onClick={() => setIsOpen(true)}>
                  <IoMenuSharp className="h-6 w-7" />
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* Mobile Drawer */}
        <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
          <DrawerOverlay>
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader>Menu</DrawerHeader>
              <DrawerBody>
                <div className="flex flex-col items-center mt-2 w-full h-screen divide-y divide-slate-200">
                  <Link
                    to="/homepage"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Home</div>
                  </Link>

                  <div className="w-full text-lg font-bold text-gray-800 cursor-pointer">
                    <div
                      className="w-full p-2 hover:bg-[#EFF6FF] flex justify-between items-center"
                      onClick={() => setIsHovered(!isHovered)}
                    >
                      Services {isHovered ? <ChevronUp /> : <ChevronDown />}
                    </div>
                    {isHovered && (
                      <div className="w-full bg-white shadow-lg rounded-b-lg">
                        <ul className="py-2 text-sm text-gray-700">
                          <li>
                            <Link
                              to="/breaks"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Brakes
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/clutch"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Clutch & Transmissions
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/electrical"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Electrical
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/engine"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Engine Diagnostics
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/exhaust"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Exhaust
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/fuel"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Fuel
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/maintenance"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Maintenance
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/radiators"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Radiators & Cooling
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/suspension"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Suspension & Steering
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/transfer"
                              className="block px-4 py-2 hover:bg-gray-100"
                              onClick={onClose}
                            >
                              Transfer Case & Differentials
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>

                  <Link
                    to="/shop"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Shop</div>
                  </Link>
                  <Link
                    to="/blog"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Blogs</div>
                  </Link>
                  <Link
                    to="/about-us"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">About us</div>
                  </Link>
                  <Link
                    to="/contact-us"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">
                      Contact us
                    </div>
                  </Link>
                </div>
              </DrawerBody>
            </DrawerContent>
          </DrawerOverlay>
        </Drawer>
      </div>
    </>
  );
};

// Chakra (Circle) import is fine, but if Chakra isn't available in your build it can cause
// “Element type is invalid… got: object”. Fallback to a simple span.
const Badge = ({ children, className = "" }) => (
  <span className={className} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
    {children}
  </span>
);

export default NavBar;
